import React from "react";
import {NavLink } from "react-router-dom";

function BlogStep(props) {
  return (
    <NavLink to={props.to}>
      <img src={props.iconImgSrc} alt="" className="svg" />
      {props.content}
      <img src="/img/icons/tab-arrow.svg" alt="" className="svg tab-arrow" />
    </NavLink>
  );
}

export default BlogStep;
